import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "nested"
  }, [_vm._l(_vm.headerList, function (el, i) {
    return _c("li", {
      key: el.id
    }, [el.id && el.platform === _vm.platform ? [_c("controller", {
      class: {
        "is-disabled": _vm.filterList.includes(el.name)
      },
      attrs: {
        id: el.id,
        title: el.title,
        index: i,
        components: _vm.headerList
      },
      on: {
        "update:title": function updateTitle($event) {
          return _vm.$set(el, "title", $event);
        }
      }
    }, [_c(el.componentPack.componentViewName, {
      tag: "component",
      class: "component_" + el.id,
      attrs: {
        id: el.id,
        formData: el.componentValue
      }
    })], 1)] : _vm._e(), !el.id ? [_vm._v(" wating.... ")] : _vm._e()], 2);
  }), _c("div", {
    staticClass: "main"
  }, [_c("draggable", {
    staticClass: "dragArea",
    attrs: {
      tag: "ul",
      group: {
        name: "people"
      },
      list: _vm.mainList,
      filter: ".is-disabled",
      preventOnFilter: false,
      move: _vm.onMove,
      options: {
        setData: _vm.setDragImg
      },
      clone: _vm.handleClone
    },
    on: {
      change: _vm.handle_drag_change,
      end: _vm.handleEnd
    }
  }, _vm._l(_vm.mainList, function (el, i) {
    return _c("li", {
      key: el.id,
      attrs: {
        "data-name": el.name
      }
    }, [el.id && el.platform === _vm.platform && el.componentValue.location.includes(_vm.platform == "pc" ? 1 : 2) ? [_c("controller", {
      class: {
        "is-disabled": true
      },
      attrs: {
        id: el.id,
        title: el.title,
        components: _vm.mainList,
        index: i
      },
      on: {
        "update:title": function updateTitle($event) {
          return _vm.$set(el, "title", $event);
        }
      }
    }, [_c(el.componentPack.componentViewName, {
      ref: el.name,
      refInFor: true,
      tag: "component",
      class: "component_" + el.id,
      attrs: {
        id: el.id,
        formData: el.componentValue
      }
    })], 1)] : _vm._e(), !el.id ? [_vm._v(_vm._s(el) + " wating.... ")] : _vm._e()], 2);
  }), 0), _vm.mainList.length == 0 ? _c("div", {
    staticClass: "is-empty"
  }, [_vm._v("请从左侧添加组件")]) : _vm._e()], 1), _vm._l(_vm.footerList, function (el, i) {
    return _c("li", {
      key: el.id
    }, [el.id && el.platform === _vm.platform ? [_c("controller", {
      class: {
        "is-disabled": _vm.filterList.includes(el.name)
      },
      attrs: {
        id: el.id,
        title: el.title,
        index: i,
        components: _vm.footerList
      },
      on: {
        "update:title": function updateTitle($event) {
          return _vm.$set(el, "title", $event);
        }
      }
    }, [_c(el.componentPack.componentViewName, {
      tag: "component",
      class: "component_" + el.id,
      attrs: {
        id: el.id,
        formData: el.componentValue
      }
    })], 1)] : _vm._e(), !el.id ? [_vm._v(" wating.... ")] : _vm._e()], 2);
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };